<template>
  <el-form
    ref="form-data"
    label-width="100px"
    :inline="setting.inline"
    :rules="rules"
    :label-position="setting.label_position || left"
    :model="submit_data"
    :size="setting.size"
  >
    <el-form-item
      v-for="(field,index) in fields.filter((item) => !item.isVisible || item.isVisible === 'yes')"
      v-bind="field.attrs || {}"
      :key="index"
      class="edit-form"
      style="margin-bottom: 22px;"
      :label="field.label"
      :prop="field.key"
      :size="field.size"
    >
      <component
        :is="components[field.type] || 'SlsInput'"
        :Data="field"
        :SubmitData="submit_data"
        :SubmitInfo="submit_info"
        :TempFieldObj="temp_field_obj"
        @on-key-enter="onKeyEnter"
        @keydown.enter.prevent="onKeyEnter"
      />
    </el-form-item>

    <el-form-item>
      <el-button
        size="default"
        icon="Search"
        type="primary"
        :plain="StylePlain"
        @click="onSubmit('form-data')"
      >
        Buscar
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import Fields from './fields';

export default {
  name: 'CcFormData',
  components: Fields,

  props: {
    FieldList: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },

    Editor: {
      type: Object,
      default() {
        return {};
      },
    },

    Rules: {
      type: Object,
      default() {
        return {};
      },
    },

    DefaultValue: {
      type: Object,
      default() {
        return {};
      },
    },

    Setting: {
      type: Object,
      default() {
        return {};
      },
    },

    PrimaryKey: {
      type: String,
      default: 'id',
    },

    StylePlain: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['onSubmit'],
  data() {
    const self = this;
    return {
      setting: self.Setting,
      primary_key: self.PrimaryKey,
      fields: self.FieldList,
      components: {
        input: 'SlsInput',
        textarea: 'SlsTextarea',
        select: 'SlsSelect',
        radio: 'SlsRadio',
        switch: 'SlsSwitch',
        cascader: 'SlsCascader',
        checkbox: 'SlsCheckbox',
        date: 'SlsDate',
        daterange: 'SlsDateRange',
        year: 'SlsDateYear',
        month: 'SlsDateMonth',
        week: 'SlsDateWeek',
        time: 'SlsTime',
        timerange: 'SlsTimeRange',
        timefixed: 'SlsTimeFixed',
        timefixedrange: 'SlsTimeFixedRange',
        datetime: 'SlsDateTime',
        datetimerange: 'SlsDateTimeRange',
        editor: 'SlsEditor',
        number: 'SlsInputNumber',
      },
      cur_component: '',
      temp_field_obj: {},
      submit_data: self.DefaultValue,
      submit_info: {},
      rules: self.Rules || {},
    };
  },

  /**
  *
  * @type {Object}
  */
  watch: {
    FieldList: {
      deep: true,
      handler(v) {
        if (v) {
          this.fields = v;
        }
      },
    },

    submit_data: {
      deep: true,
      /* eslint-disable no-unused-vars */
      handler(v) {
      },
    },

    DefaultValue: {
      deep: true,
      handler(v) {
        this.default_value = v;
      },
    },

    wangeditor_update(v) {
    },

    Setting(v) {
      this.setting = v;
    },

    PrimaryKey(v) {
      this.primary_key = v;
    },
  },

  methods: {
    /**
    * Evento de submit
    */
    onSubmit(ref) {
      const data = {
        data: this.submit_data,
        info: this.submit_info,
      };

      if (this.rules) {
        this.$refs[ref].validate((valid) => {
          if (valid) {
            this.$emit('onSubmit', data);
          }
        });
      } else {
        this.$emit('onSubmit', data);
      }
    },
    onKeyEnter() {
      this.onSubmit('form-data');
    },
    /**
    * Tornar os dados do form acessíveis
    */
    getSubmitData() {
      return this.submit_data;
    },
  },
};
</script>
